import React, { useState, useEffect, useContext } from 'react';
import * as fkn from "../../lib/fkn";
import * as net from "../../lib/net";
import Dt_Cal from "../../lib/ui/dt_cal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


class Pms_Period extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, dta: [], tot: {} };
    this.state.fdat = new Date();
    this.state.tdat = new Date();
    this.state.fkn = "";
    this.state.tot.fsg = 0;
    this.state.tot.bet = 0;
    this.state.tot.diff = 0;
    //this.state.units = [];
    //context.posrend = this;
    let cdat = new Date();
    let formatted_date = cdat.getFullYear() + "-" + (cdat.getMonth() + 1) + "-" + cdat.getDate();
    this.state.today = formatted_date;
    this.state.fdatum = formatted_date;
    this.state.tdatum = formatted_date;
  }
  componentDidUpdate() {
    let value = this.context;
    /* ... */
  }
  componentWillUnmount() {
    let value = this.context;
    /* ... */
  }
  componentDidMount() {
    //this.props.fetchWells()
    //  .then(res => this.setState({ wells: res.wells }) )
    //this.trans();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 250;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }
  change_fdat(e) {
    //let cdat = this.state.seldate;
      if(e.value == null) return;

    let cdat = e.value;
    let formatted_date = cdat.getFullYear() + "-" + (cdat.getMonth() + 1).toString().tonum(2) + "-" + cdat.getDate().toString().tonum(2);
    this.setState({fdat: e.value});
    this.setState({fdatum: formatted_date});
    this.setState({tra: [] });
  }
  change_tdat(e) {
    //let cdat = this.state.seldate;
      if(e.value == null) return;
    let cdat = e.value;
    let formatted_date = cdat.getFullYear() + "-" + (cdat.getMonth() + 1).toString().tonum(2) + "-" + cdat.getDate().toString().tonum(2);
    this.setState({tdat: e.value});
    this.setState({tdatum: formatted_date});
    this.setState({tra: [] });
  }
  change_fkn(e) {
    //let cdat = this.state.seldate;
    //alert(JSON.stringify(e));
    let fkn = e.target.value;
    this.setState({fkn: fkn});
    this.setState({tra: [], tsa: [], tta: [] });
  }

  dt_period() {
    var self = this;
    var prm = {};
    prm.req = "pms.eko_red.red_period";
    prm.fdat = this.state.fdatum;
    prm.tdat = this.state.tdatum;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        if(ret.ok != "000") {
            return;
        }
        var dta = [];
        var dto = ret.sdo.dto;
        var keys = Object.keys(dto);
        for(var key of keys) {
            var o = dto[key];
            dta.push( o );
        }
        self.setState({dta: dta, tot: ret.sdo.tot });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
    }

  render() {
    return (
    <div className="web-app" style={{margin: "0px", padding: "5px 10px"}}>
    <h3>Hotell Period</h3>

    <div className="flex-row flex-space-between">
        <div className="flex-row">
            <div className="flex-row">
                <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
                <Dt_Cal dts={this.state.dts} rp="1" ref={this.dt_dt} getValue={(e)=> this.dt_dat(e)} />
                <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
            </div>
            <div className="flex-row">
                <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
                <Dt_Cal dts={this.state.dts} rp="1" ref={this.dt_dt} getValue={(e)=> this.dt_dat(e)} />
                <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
            </div>
        </div>
        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.dt_period() } aria-label="System" >
            Visa
        </button>
    </div>
    <div className="divider">
    </div>

        <div className="web-row">
            <table className="table table-bordered table-hover tb fixed_header">
                <thead>
                <tr>
                    <th>Datum</th>
                    <th>Text</th>
                    <th>Fsg</th>
                    <th>Bet</th>
                    <th>Diff</th>
                    <th>Krubba</th>
                    <th>Status</th>
                </tr>
                </thead>
                <tbody style={ this.tb_style() }>
                { this.state.dta.map((row, key) =>
                    <tr id={ row.datum } ng-dblclick="trans_open(row);">
                        <td>{ row.datum }</td>
                        <td>{ row.name }</td>
                        <td>{ row.tot.fsg.cdipris() }</td>
                        <td>{ row.tot.bet.cdipris() }</td>
                        <td>{ row.tot.diff.cdipris() }</td>
                        <td>{ row.krubba.cdipris() }</td>
                        <td>{ row.status }</td>
                    </tr>
                )}
                <tr id="tot" ng-dblclick="trans_open(row);">
                    <td>Totalt</td>
                    <td></td>
                    <td>{ this.state.tot.fsg.cdipris() }</td>
                    <td>{ this.state.tot.bet.cdipris() }</td>
                    <td>{ this.state.tot.diff.cdipris() }</td>
                    <td></td>
                    <td></td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
  );
}
}
export default Pms_Period;
